// extracted by mini-css-extract-plugin
export default {"container":"quotation-table-header_container__vws-U"};